import { useState } from "react";
import Card from "components/card";
import { PartnerReportView } from "components/backoffice/Backoffice";
import { useAuth } from "contexts/AuthContext";

export default function PartnerReportsPage() {
  const { portal } = useAuth();
  const [period, setPeriod] = useState("30d");
  const tenantName = portal?.tenant?.name || "your tenant";
  return (
    <Card extra="p-4 sm:p-5">
      <PartnerReportView
        path="/portal/partner/report"
        exportPath="/portal/partner/report/export"
        period={period}
        onPeriodChange={setPeriod}
        title="Your markets report"
        description={`Every market you created, its trading activity and the revenue it earned in the period you pick. Only your own markets and money appear here. Viewing and exporting this report is recorded, and ${tenantName} can see that record.`}
      />
    </Card>
  );
}
